import React from 'react';
import PropTypes from 'prop-types';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import DataService from '../../lib/DataService';

import { hashHistory } from 'react-router'

export default class ArchiveReviewSchoolPage extends React.Component {
  static propTypes = {
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      currentRole: CurrentRoleStore.getCurrentRole(),
      schoolId: parseInt(props.params.schoolId),

      grades: []
    };
    // bind this
    this.goToClassDetail = this.goToClassDetail.bind(this);
  }

  componentDidMount() {
    if (!(this.state.currentRole && (this.state.currentRole.associatName == 'classGrade' || this.state.currentRole.associatName == 'school' || this.state.currentRole.associatName == 'system'))) {
      hashHistory.push('error/unauthorized');
      return;
    }

    // get archive status in school
    DataService.getArchiveStatusForSchool(this.state.schoolId).then((response) => {
      let grades = [];
      response.forEach((classRecord) => {
        if (!classRecord.is_deleted && !classRecord.is_graduated) {
          let existGrade = grades.find((grade) => grade.id == classRecord.class_grade_id);
          if (!existGrade) {
            existGrade = {
              id: classRecord.class_grade_id,
              name: classRecord.grade_name,
              number: classRecord.grade_number,
              classes: []
            };
            if (this.state.currentRole.associatName == 'system' || this.state.currentRole.associatName == 'school' ||
                (this.state.currentRole.associatName == 'classGrade' && this.state.currentRole.associatObj.id == existGrade.id))
              grades.push(existGrade);      // for grade admin, only show the grade info in which he has right
          }
          existGrade.classes.push({
            id: classRecord.id,
            name: classRecord.name,
            reviewedCount: classRecord.reviewed_count,
            studentCount: classRecord.student_count,
            pagesNeedReviewCount: classRecord.pages_need_review_count,
            archivePageCount: classRecord.page_count
          })
        }
      });
      this.setState({
        grades: grades
      });
    }, (response) => {
      // error response: {status: XXX, errorMessage: {errors: [{message: "Class not found", code: 41}]}}
    }).catch((error) => {
      // catch any error above block ('then' block)
    });
  }

  goToClassDetail(e) {
    let gradeId = parseInt(e.currentTarget.dataset.gradeid), classId = parseInt(e.currentTarget.dataset.classid);
    let grade = this.state.grades.find((grade) => grade.id == gradeId);
    if (grade) {
      let classRecord = grade.classes.find((classRecord) => classRecord.id == classId);
      if (classRecord && classRecord.archivePageCount)
        hashHistory.push(`archive/review/classes/${classId}`);
    }
  }

  render() {
    return (
      <div className="archive-review-school-page">
        {this.state.grades.map((grade) =>
          <div className="grade-container" key={grade.id}>
            <div className="grade-name">{grade.name}</div>
            <div className="classes-container">
              {grade.classes.map((classRecord) =>
                <div className="class-container" data-classid={classRecord.id} data-gradeid={grade.id} key={classRecord.id} onClick={this.goToClassDetail}>
                  <div className="class-name">{classRecord.name}</div>
                  <div className="content">已审核模板: {(classRecord.pagesNeedReviewCount && classRecord.studentCount && classRecord.studentCount * classRecord.pagesNeedReviewCount != 0) ? `${Math.floor(classRecord.reviewedCount / (classRecord.studentCount * classRecord.pagesNeedReviewCount) * 100)}%` : '(无)'}</div>
                  <div className="content">需审核模板: {classRecord.pagesNeedReviewCount ? classRecord.pagesNeedReviewCount : '(无)'}</div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/archive/ArchiveReviewSchoolPage.jsx